exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lg\\:w-1\\/2[data-v-1010ed50] {\n  width: 49% !important;\n}\n", ""]);

// exports
